<template>
  <!--保管函-->
  <div class="body">
    <role-tab :tabs="bindCorpUsers"></role-tab>
    <!-- <service-tabbar current="1" /> -->
    <!--<el-row class="row" :gutter="20" style="margin: 0;">-->
    <!--<el-col :span="2">-->
    <!--<p style="line-height: 34px; font-weight: 600;">状态</p>-->
    <!--</el-col>-->
    <!--<el-col :span="3">-->
    <!--<el-select v-model="caseStatus" placeholder="请选择状态" size="small">-->
    <!--<el-option label="全部" value=""/>-->
    <!--<el-option label="未支付" :value="0"/>-->
    <!--<el-option label="已支付" :value="1"/>-->
    <!--<el-option label="待签署/处理中" :value="2"/>-->
    <!--<el-option label="已签署/处理完成" :value="3"/>-->
    <!--<el-option label="被驳回" :value="4"/>-->
    <!--</el-select>-->
    <!--</el-col>-->
    <!--<el-col :span="7" style="text-align: right">-->
    <!--<el-button @click="queryList()" size="small">查询</el-button>-->
    <!--</el-col>-->
    <!--</el-row>-->
    <div class="content">
      <div class="left-tab-warp">
        <left-tab></left-tab>
      </div>
      <div class="right-wrap">
        <div class="right-content">
          <div class="right-toolbar">
            <h2 class="title">保管函</h2>
          </div>
          <div class="right flex-between">
            <div>
              <el-button @click="gotoSignList" class="btn" type="primary" plain size="small">去出证</el-button>
            </div>
            <div>
              <el-date-picker
                v-model="datePikerArr"
                type="daterange"
                value-format="yyyy-MM-dd"
                :default-time="['00:00:00', '23:59:59']"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                size="small"
                style="width: 250px; margin-right: 8px"
              />
              <el-input
                style="width: 160px; margin-right: 8px"
                size="small"
                type="number"
                :clearable="true"
                placeholder="请输入数字备案号"
                v-model="preservationId"
              ></el-input>
              <el-select
                style="width: 140px; margin-right: 8px"
                size="small"
                v-model="status"
                placeholder="订单状态"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-button @click="queryList" size="small">查询</el-button>
              <el-button @click="rest" size="small">重置</el-button>
            </div>
          </div>
          <div class="table-warp">
<!--                      :style="{ 'min-height': tableHeight + 'px' }"-->
            <el-table
              v-loading="loading"
              class="data-list"
              :data="listData"
              tooltip-effect="dark"
              @selection-change="handleSelectionChange"
              :header-cell-style="{
                background: '#f9f9f9',
                color: '#333333',
                fontWeight: '500',
              }"
              :style="{ 'min-height': '64vh' }"
            >
              <el-table-column label="订单号" prop="orderNumber" show-overflow-tooltip />
              <el-table-column label="备案号" prop="preservationId" show-overflow-tooltip />
              <el-table-column label="持有人" prop="preservationName" show-overflow-tooltip></el-table-column>
              <el-table-column label="出证机关" prop="orgName" show-overflow-tooltip></el-table-column>
              <el-table-column label="创建日期" prop="username" show-overflow-tooltip>
                <template slot-scope="scope">
                  {{
                  scope.row.createTime | formatDateTime
                  }}
                </template>
              </el-table-column>
              <el-table-column label="订单状态" prop="statusStr" show-overflow-tooltip></el-table-column>
              <el-table-column label="操作" width="100">
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.status === 1"
                    @click="toDealCase(scope.row)"
                    class="color-success pointer"
                  >立即支付</span>
                  <span
                    v-if="scope.row.status === 4"
                    @click="downfile(scope.row.orderNumber)"
                    class="color-success pointer"
                  >下载保管函</span>
                </template>
              </el-table-column>
              <!--        <no-data text="还未申请过保管函" slot="empty"/>-->
              <div slot="empty" class="com-custom-nodata">
                <img class="simg" src="/images/judicialService/bgh-no-data.png" />
              </div>
            </el-table>
            <el-row class="pageation row" v-if="listData && listData.length > 0">
              <el-col :span="24" class="page-flex-end">
                <el-pagination
                  v-if="paged.total > 0"
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :pager-count="5"
                  :total="paged.total"
                  :current-page.sync="paged.pageNum"
                  :page-size="paged.pageSize"
                  :page-sizes="[10, 20, 50, 100]"
                  layout="sizes, prev, pager, next, total"
                />
                <el-go
                  :page-size="paged.pageSize"
                  :total="paged.total"
                  @current-change="handleCurrentChange"
                ></el-go>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ApiMethods } from "@/assets/js/http-serve/http-methods";
import ElGo from "@/components/go/Go";
import LeftTab from "@/components/judicialService/leftTab";
import ServiceTabbar from "@/components/judicialService/tabbar";
import RoleTab from "@/components/role-tab";
import { changeLgAccount } from "../../assets/js/http-serve/corp/common";
import { ApiCorpMethods } from "../../assets/js/http-serve/corp/http-methods";
import { gantConf } from "../../assets/js/utils/jurisdiction";
import { mapGetters } from "vuex";
import { isInDingTalk } from "@/assets/js/utils/ding-env";

export default {
  components: { ElGo, LeftTab, ServiceTabbar, RoleTab },
  methods: {
    gotoSignList () {
      this.$router.push({
        path: this.currentAuthUser.corpId ? "/corp/signInfo/signList?signStatus=3" : "/signInfo/signList?signStatus=3"
      });
      // changeLgAccount()
      //   .then(res => {
      //     // 切换到登录账户
      //     this.$router.push({
      //       path: "/signInfo/signList?signStatus=3"
      //     });
      //   })
      //   .catch(e => {
      //     this.$message.error("操作失败");
      //   });
    },
    toDealCase (item) {
      var newWindow;
      if (!isInDingTalk) newWindow = window.open();
      this.loading = true;
      // this.currentAuthUser.corpId 存在就说明是加入的企业
      let APIs = this.currentAuthUser.corpId ? ApiCorpMethods : ApiMethods;
      APIs.SafeguardController.getKeepInit({
        preservationId: item.preservationId,
        certCode: item.certCode,
        orgCode: item.orgCode
      })
        .then(result => {
          if (!result.success)
            return this.$message.error(result.description || "操作失败");
          isInDingTalk ? location.href = result.data : newWindow.location.href = result.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    downfile (orderNumber) {
      // this.currentAuthUser.corpId 存在就说明是加入的企业
      let APIs = this.currentAuthUser.corpId ? ApiCorpMethods : ApiMethods;
      APIs.SafeguardController.safeKeepLetterLink({
        orderNumber: orderNumber
      }).then(result => {
        if (!result.success)
          return this.$message.error(result.description || "下载失败");
        if (isInDingTalk) {
          this.$DingSDKPromise().then((SDK)=>{
            SDK.downloadFile({
              url: result.data,
              success: (res) => {
                const { filePath } = res;
              },
              fail: () => { },
              complete: () => { },
            });
          }).catch(err=>{
            console.error('钉钉环境准备失败:',err);
          });
        } else {
          // location.href = result.data;
          // https网站请求下载http的资源会被拦截，使用window.open下载
          window.open(result.data);
        }
      });
    },
    // 重置
    rest () {
      this.paged.pageNum = 1;
      this.beginDate = null;
      this.endDate = null;
      this.preservationId = "";
      this.status = "";
      this.datePikerArr = [];
      this.queryList();
    },
    queryList () {
      let param = {
        pageSize: this.paged.pageSize,
        itemPage: this.paged.pageNum,
        beginDate: this.beginDate,
        endDate: this.endDate,
        preservationId: this.preservationId,
        status: this.status
      };
      this.loading = true;
      // this.currentAuthUser.corpId 存在就说明是加入的企业
      let APIs = this.currentAuthUser.corpId
        ? ApiCorpMethods.SafeguardController.safeKeepLetter
        : ApiMethods.SafeguardController.querySafeKeepLetter;
      // ApiMethods.SafeguardController.querySafeKeepLetter(param)
      APIs(param)
        .then(result => {
          if (
            !result.success &&
            this.$store.getters.authUser.identityAuth > -1
          ) {
            return this.$message.error(result.description || "查询数据失败");
          }
          this.paged = {
            pageNum: result.pageNum,
            pageSize: result.pageSize,
            pages: result.pages,
            total: result.total
          };
          this.listData = result.data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    handleSelectionChange (val) {
      this.checkedList = val;
    },
    handleCurrentChange (val) {
      this.paged.pageNum = val;
      this.queryList();
    },
    handleSizeChange (val) {
      this.paged.pageSize = val;
      this.queryList();
    }
  },
  computed: {
    ...mapGetters(["currentAuthUser", "allAuthUser"]),
    // 返回需要显示tab的绑定数据
    bindCorpUsers () {
      let { memberCert, arbitrate } = gantConf,
        arr = [];
      // 遍历加入的企业，判断加入的企业是否含有成员证书管理权限。如果没有就不显示该企业
      this.allAuthUser.bindCorpUsers.forEach(user => {
        const have = user.perms.includes(memberCert) || user.perms.includes(arbitrate)
        if(isInDingTalk){
          const info = JSON.parse(sessionStorage.getItem("dingloginInfo"));
          if(info.jzqCorpId === user.corpId && have){
            arr.push(user);
          }
        }else if (have) {
          arr.push(user);
        }
      });
      let bind = {
        // haveBind 表示是否要用 binds中的数据
        haveBind: true,
        binds: arr
      };
      console.log('bind',bind);
      return bind;
    },
    arbitrationAuth () {
      return (this.currentAuthUser.corpId && this.currentAuthUser.perms.includes(gantConf.memberCert)) || !this.currentAuthUser.corpId;
    },
  },
  watch: {
    currentAuthUser: {
      handler (val) {
        if (!this.arbitrationAuth && this.$route.path === '/judicialService/baoguanhan') {
          this.$router.replace('/judicialService/applyArbitration', () => { }, () => { })
        } else {
          this.queryList();
        }
      },
      deep: true
    },
    datePikerArr: {
      handler (val) {
        if (val && val.length === 2) {
          this.beginDate = val[0];
          this.endDate = val[1];
        } else {
          this.beginDate = this.endDate = null;
        }
      },
      deep: true
    }
  },
  created () {
    if (!this.arbitrationAuth && this.$route.path === '/judicialService/safeguard') {
      this.$router.replace('/judicialService/applyArbitration')
    } else {
      this.queryList();
    }
  },
  mounted () {
    // 适配高度（底部可能没有）
    let height = this.tableHeight;
    try {
      let body = document.getElementsByTagName("body");
      let header = document.getElementsByClassName("el-header");
      let pageation = document.getElementsByClassName("pageation");
      let contacts = document.getElementsByClassName("contacts");
      let footer = document.getElementsByClassName("el-footer");
      body = body && body.length > 0 ? body[0].clientHeight : 0;
      header = header && header.length > 0 ? header[0].clientHeight : 0;
      pageation =
        pageation && pageation.length > 0 ? pageation[0].clientHeight : 0;
      contacts = contacts && contacts.length > 0 ? contacts[0].clientHeight : 0;
      footer = footer && footer.length > 0 ? footer[0].clientHeight : 0;
      height = body - header - pageation - contacts - footer - 90;
    } catch (e) {
      console.error(e);
    }
    this.tableHeight = height;
  },
  data () {
    return {
      gantConf,
      paged: { pageNum: 1, pageSize: 10 },
      listData: [],
      caseStatus: "",
      loading: false,
      getStatus: [
        "未支付",
        "已支付",
        "待签署/处理中",
        "已签署/处理完成",
        "被驳回"
      ],
      tableHeight: 700,
      datePikerArr: null,
      preservationId: "",
      status: "",
      beginDate: null,
      endDate: null,
      options: [
        {
          label: "未支付",
          value: 1
        },
        {
          label: "已支付",
          value: 2
        },
        {
          label: "出证办理中",
          value: 3
        },
        {
          label: "已出证",
          value: 4
        },
        {
          label: "未通过",
          value: 5
        },
        {
          label: "无",
          value: -1
        }
      ]
    };
  },
  name: "baoguanhan"
};
</script>

<style lang="less" scoped>
.flex-between {
  padding: 15px 15px 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.table-box {
  padding-top: 20px;
}

.body {
  height: 100%;
  // max-width: 1200px;
  // position: relative;
  // display: block;
  // margin: 76px auto 0;
  // background: #ffffff;
  // border-radius: 14px;
  // box-sizing: border-box;
  // padding: 20px 15px 15px;
  .safeguard-bar {
    width: 100%;
    margin-top: 20px;
    border: 1px dashed #d7d7d7;
    overflow: hidden;

    ul {
      li {
        display: inline-block;
        margin-right: 14px;
        padding: 10px;
        color: #666;
        border: none;
        background: #fff;
        cursor: pointer;
      }

      li.active {
        color: #ec1c1c;
      }
    }
  }

  .pageation {
    padding: 30px 10px 20px 10px;
    border-top: 0;
  }

  .dialog-footer {
    padding-bottom: 20px;

    .btn {
      width: 30%;
    }
  }
}

.color-success {
  color: #290202;
  font-weight: bold;
  cursor: pointer;
}
.color-success:hover {
  color: #ec1c1c;
}
.right-wrap {
  position: relative;
  padding-left: 5px;
  flex: 1;
  width: 0;
  .table-wrap {
    padding: 0 16px;
  }

  /deep/ .row {
    padding: 15px;
    height: 62px;
    min-height: 62px;
  }

  /deep/ .data-list {
    /*height: calc(100vh - 330px);*/
    width: inherit;
    margin: 0 0;
    border: 1px solid #eeeeee;
    margin-top: 15px;
  }

  /deep/ .el-table__body-wrapper {
    height: calc(100% - 48px);
    overflow-y: auto;
  }

  /deep/ .go-style {
    top: 17px;
  }
}
.content {
  background: #f8f8f8;
  border-radius: 8px;
  box-sizing: border-box;
  // padding: 25px 15px 10px;
  display: flex;
}
.left-tab-warp {
  flex: 0 0 200px;
}
.right-content {
  width: 100%;

  background-color: #fff;
  box-sizing: border-box;
}
.com-custom-nodata {
  padding-top: 90px;
  img {
    width: 690px;
    height: auto;
    display: block;
    margin: 0 auto;
  }
}
.table-warp {
  width: 100%;
  box-sizing: border-box;
  padding: 0 15px;
}
.right-toolbar {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #eee;
  .title {
    font-size: 16px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    line-height: 30px;
    display: flex;
    align-items: center;
    color: #290202;
    &::before {
      content: "";
      width: 5px;
      height: 15px;
      background: #290202;
      margin-right: 10px;
    }
  }
  .right {
    height: 100%;
    display: flex;
    align-items: center;
    padding-right: 5px;
  }
  .btn {
    width: 65px;
    margin-right: 10px;
    padding: 8px 15px;
  }
}
</style>



// WEBPACK FOOTER //
// pages/judicialService/baoguanhan.vue